import {
  APIResponseCollectionPagination,
  APIOffsetBasedPagination,
} from "@superagents/types/api";

export const PAGINATION = {
  defaultLimit: 25,
  maxLimit: 100,
  defaultWithCount: true,
  defaultOffset: 0,
};

export const getNextOffset = (
  currentStart: number,
  currentLimit: number,
  totalEntries: number
) => {
  const hasNextPage = currentStart + currentLimit < totalEntries;

  return hasNextPage ? currentStart + currentLimit : undefined;
};

/**
 * Próxima página (paginação por número de página) pelos itens já carregados:
 * uma página que veio menor que o tamanho (item apagado no meio) não esconde
 * o resto, e uma página vazia encerra.
 */
export const getNextPageByLoaded = <
  T extends { items: unknown[]; total: number },
>(
  lastPage: T,
  pages: T[]
): number | undefined => {
  const loaded = pages.reduce((sum, page) => sum + page.items.length, 0);
  return lastPage.items.length > 0 && loaded < lastPage.total
    ? pages.length + 1
    : undefined;
};

const isOffsetBasedPagination = (
  pagination: APIResponseCollectionPagination
): pagination is APIOffsetBasedPagination => {
  return "start" in pagination && "limit" in pagination;
};

export const getPaginationParams = (
  pagination: APIResponseCollectionPagination
) => {
  if (isOffsetBasedPagination(pagination)) {
    return {
      start: pagination.start ?? PAGINATION.defaultOffset,
      limit: pagination.limit ?? PAGINATION.defaultLimit,
      total: pagination.total ?? 0,
    };
  }

  const page = pagination.page ?? 0;
  const pageSize = pagination.pageSize ?? PAGINATION.defaultLimit;

  return {
    start: page * pageSize,
    limit: pageSize,
    total: pagination.total ?? 0,
  };
};
